import {
  HwcgDirectoryImportDialog,
  type DirectoryImportField,
} from './HwcgDirectoryImportDialog';

const COMPANY_FIELDS: DirectoryImportField[] = [
  { field: 'companyName', label: 'Company name' },
  { field: 'eocLocation', label: 'EOC location' },
  { field: 'officeLocation', label: 'Office location' },
];

export function HwcgMemberCompanyImportDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <HwcgDirectoryImportDialog
      open={open}
      onOpenChange={onOpenChange}
      kind="companies"
      title="Import member companies"
      noun="company"
      nounPlural="companies"
      fields={COMPANY_FIELDS}
      requiredAnyOf={['companyName']}
      rowLabel={(fields) =>
        typeof fields.companyName === 'string' && fields.companyName
          ? fields.companyName
          : '—'
      }
    />
  );
}
